import { Heading } from '@vista-digital/occ-ui'
import React from 'react'

import { GridElement } from '..'
import { JumpHeading, PagePromotionCard } from '../../components'

import './page-promotion.scss'
import { PagePromotionCardPropsApi } from '../../components/pagePromotionCard/models'

export interface PagePromotionProps extends GridElement {
    value: {
        heading?: string
        promotedPages: PagePromotionCardPropsApi[]
    }
}

export const PagePromotion: React.FC<PagePromotionProps> = props => {
    const { heading, promotedPages } = props.value

    if (!promotedPages || promotedPages.length === 0) {
        return null
    }

    const cardsIndex: number = promotedPages.length - 1

    const classSuffixes = ['one', 'two', 'three', 'four', 'five', 'six', 'seven', 'eight', 'nine', 'ten']

    return (
        <div className={`page-promo`}>
            {heading && <JumpHeading text={heading} />}
            <div className={`page-promo-grid page-promo-grid-${classSuffixes[cardsIndex]}`}>
                {promotedPages.map(page => (
                    <PagePromotionCard key={`promo-${promotedPages.indexOf(page)}`} {...page} />
                ))}
            </div>
        </div>
    )
}
